import { GetLastRecordWithBreakResponse } from "../../../ApiOld/Api/ApiServerVov";

export interface Activity {
    mainButtonName: string;
    lastActivityName: string;
    lastActivityText: string;
    lastActivityDate: Date | null | undefined;
    breakAndTranstionDisabled: boolean;
    nextActivityType: string
    buildingId: number | undefined;
    runningBreak: boolean;
}

export function GetCurrentInfo(lastActivity: GetLastRecordWithBreakResponse): Activity {
    let lastActivityName = '';
    let lastActivityText = '';

    if (lastActivity.type === "1" || lastActivity.type === "3" || lastActivity.type === "12_1" || lastActivity.type === "12_0") {
        lastActivityName = lastActivity.buildingName ?? '';
    }
    else if (lastActivity.type === "4") {
        lastActivityName = "Odchod";
    }

    if (lastActivity.type === "1" || lastActivity.type === "12_1" || lastActivity.type === "12_0") {
        lastActivityText = 'LoggedInTo';
    }
    else {
        lastActivityText = lastActivity.type !== '' ? 'Recently' : '';
    }
    return {
        mainButtonName: lastActivity.type !== '1' && lastActivity.type !== "12_1" && lastActivity.type !== "12_0" ? 'ArrivalAtWork' : 'LeavingWork',
        lastActivityName: lastActivityName,
        lastActivityText: lastActivityText,
        lastActivityDate: lastActivity.date,
        breakAndTranstionDisabled: lastActivity.type !== undefined && lastActivity.type !== "1" && lastActivity.type !== "12_1" && lastActivity.type !== "12_0",
        nextActivityType: lastActivity.type !== '1' && lastActivity.type !== "12_1" && lastActivity.type !== "12_0" ? '1' : '4',
        buildingId: lastActivity.buildingId,
        runningBreak: lastActivity.type === "12_1",
    };
};